/* pdp-color-media-jr.js
   Filters the PDP gallery (sections/product-main.liquid) down to the media that
   belongs to the currently selected Color.

   Data comes from window.jrPdpColorMedia, rendered by layout/theme.liquid:
     { pos: 1|2|3, count: <product.media.size>, starts: { "Olive": 0, "Black": 6 }, selected: "Black" }

   Each colour's media block runs from its own start index up to the next
   colour's start index - 1 (last colour runs to the end). Colours whose start is
   -1 (no featured media assigned) are ignored and the gallery is left alone.

   Markup/classes are reused exactly as the section defines them, so nothing in
   the design changes: .gc-cell/.gc-cell.v, .gc-th/.gc-th.a, .gc-th-more, .gc-arr.
*/
(function () {
  'use strict';

  var CFG = window.jrPdpColorMedia;
  if (!CFG || !CFG.starts) return;

  var root = document.getElementById('gcpdp');
  if (!root) return;

  var grid = document.getElementById('gcGrid');
  var tbar = root.querySelector('.gc-tbar');
  var cells = grid ? [].slice.call(grid.querySelectorAll('.gc-cell')) : [];
  if (!cells.length) return;

  var total = cells.length;
  var MAX_THUMBS = 5;

  /* ---- build the colour -> [start,end] ranges ---- */
  var blocks = [];
  Object.keys(CFG.starts).forEach(function (name) {
    var s = CFG.starts[name];
    if (typeof s === 'number' && s >= 0 && s < total) blocks.push({ name: name, start: s });
  });
  if (!blocks.length) return;

  blocks.sort(function (a, b) { return a.start - b.start; });
  blocks.forEach(function (b, i) {
    var next = blocks[i + 1];
    b.end = next ? next.start - 1 : total - 1;
    if (b.end < b.start) b.end = b.start;
  });

  function rangeFor(color) {
    for (var i = 0; i < blocks.length; i++) {
      if (String(blocks[i].name) === String(color)) return blocks[i];
    }
    return null;
  }

  /* ---- mobile carousel handles ---- */
  var trk = document.getElementById('gcTrk');
  var mslides = trk ? [].slice.call(trk.querySelectorAll('.gc-sl')) : [];
  var mct = document.getElementById('gcMCt');
  var mnxt = document.getElementById('gcMobNxt');
  var mnxtI = document.getElementById('gcMobNxtImg');

  var cur = null;   // active range
  var ci = 0;       // active index (absolute, inside cur)

  function thumbSrc(cell) {
    var im = cell.querySelector('img');
    if (im) return im.getAttribute('src');
    var vd = cell.querySelector('video');
    return vd ? vd.getAttribute('poster') : '';
  }

  /* Replaces a node with a clone so any listener the section bound to it is
     dropped and this file becomes the only controller for that control. */
  function reclaim(el) {
    if (!el || !el.parentNode) return el;
    var c = el.cloneNode(true);
    el.parentNode.replaceChild(c, el);
    return c;
  }

  var apBtn = reclaim(document.getElementById('gcAP'));
  var anBtn = reclaim(document.getElementById('gcAN'));
  var mobPrev = reclaim(document.getElementById('gcMobPrev'));
  var mobNext = reclaim(document.getElementById('gcMobNext'));
  var mobNxtBtn = reclaim(mnxt);
  mnxtI = document.getElementById('gcMobNxtImg');

  function showAt(idx) {
    if (!cur) return;
    if (idx < cur.start) idx = cur.start;
    if (idx > cur.end) idx = cur.end;
    ci = idx;
    var right = Math.min(ci + 1, cur.end);

    cells.forEach(function (c, i) {
      c.classList.toggle('v', i === ci || i === right);
    });

    [].slice.call(tbar ? tbar.querySelectorAll('.gc-th') : []).forEach(function (t) {
      var ti = parseInt(t.getAttribute('data-ti'), 10);
      t.classList.toggle('a', ti === ci || ti === right);
    });

    var more = tbar ? tbar.querySelector('.gc-th-more') : null;
    if (more) {
      var cut = cur.start + MAX_THUMBS;
      more.classList.toggle('a', ci >= cut || right >= cut);
    }

    mgo(ci);
  }

  function mgo(idx) {
    if (!cur || !mslides.length) return;
    if (idx < cur.start) idx = cur.start;
    if (idx > cur.end) idx = cur.end;
    if (trk) trk.style.transform = 'translateX(-' + (idx * 100) + '%)';
    var len = cur.end - cur.start + 1;
    if (mct) mct.textContent = (idx - cur.start + 1) + ' / ' + len;
    var nextIdx = idx + 1;
    var hasNext = nextIdx <= cur.end;
    if (mnxtI && hasNext && cells[nextIdx]) mnxtI.src = thumbSrc(cells[nextIdx]);
    if (mobNxtBtn) mobNxtBtn.style.display = hasNext ? 'block' : 'none';
  }

  function buildThumbs() {
    if (!tbar || !cur) return;

    [].slice.call(tbar.querySelectorAll('.gc-th, .gc-th-more')).forEach(function (n) {
      n.parentNode.removeChild(n);
    });

    var len = cur.end - cur.start + 1;
    var shown = Math.min(len, MAX_THUMBS);
    var frag = document.createDocumentFragment();

    for (var k = 0; k < shown; k++) {
      var abs = cur.start + k;
      var b = document.createElement('button');
      b.className = 'gc-th';
      b.type = 'button';
      b.setAttribute('data-ti', String(abs));
      b.setAttribute('aria-label', 'Image ' + (k + 1));
      var im = document.createElement('img');
      im.src = thumbSrc(cells[abs]);
      im.alt = '';
      im.loading = 'lazy';
      b.appendChild(im);
      b.addEventListener('click', function () {
        showAt(parseInt(this.getAttribute('data-ti'), 10));
      });
      frag.appendChild(b);
    }

    if (len > MAX_THUMBS) {
      var more = document.createElement('div');
      more.className = 'gc-th-more';
      more.setAttribute('data-ti', String(cur.start + MAX_THUMBS));
      var sp = document.createElement('span');
      sp.textContent = '+ ' + (len - MAX_THUMBS);
      more.appendChild(sp);
      more.addEventListener('click', function () {
        showAt(parseInt(this.getAttribute('data-ti'), 10));
      });
      frag.appendChild(more);
    }

    tbar.insertBefore(frag, apBtn || null);
  }

  function apply(color) {
    var r = rangeFor(color);
    if (!r) return;
    cur = r;
    buildThumbs();
    showAt(r.start);
  }

  if (apBtn) apBtn.addEventListener('click', function () { showAt(ci - 1); });
  if (anBtn) anBtn.addEventListener('click', function () { showAt(ci + 1); });
  if (mobPrev) mobPrev.addEventListener('click', function () { showAt(ci - 1); });
  if (mobNext) mobNext.addEventListener('click', function () { showAt(ci + 1); });
  if (mobNxtBtn) mobNxtBtn.addEventListener('click', function () { showAt(ci + 1); });

  if (trk) {
    var sx = 0;
    trk.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    trk.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) showAt(ci + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  /* Colour swatch clicks: the section's own updateVariant() also runs, so defer
     one tick and let this file have the final say on what the gallery shows. */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest ? e.target.closest('.gc-csw') : null;
    if (!sw) return;
    if (String(sw.getAttribute('data-optidx')) !== String(CFG.pos - 1)) return;
    var val = sw.getAttribute('data-val');
    setTimeout(function () { apply(val); }, 0);
  });

  apply(CFG.selected);
})();
